import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, Text2, DataContainer, StatusData, LineContainer, MenuContainer, PagingContainer, InnerBox } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg'
import Paging from 'src/components/App/Paging';
import { Box } from '@mui/material';
import NoDataFound from '../../NoDataFound/NoDataFound';
import NotesTabForm from '../Forms/NotesTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';

const NotesCard = ({ notes = [], page, perPage, setPage, totalCount, fetchNotes }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const data = notes.map((notesData) => ({
        notesId: notesData?.id,
        note: notesData?.notes,
        addedDate: new Date(notesData.date).toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric'
        }) + `, ${notesData.time}`,
        // addedBy: 'John Doe',
    }))
    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >Add Notes</AddAppointment>

            </Container1>
            <Container2>
                <InnerAppointments >
                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Notes Found!"
                                buttonText="Add Notes"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />

                        ) : (
                            <>
                                {
                                    data.map((item) => (
                                        <BoxContainer key={item.notesId}>
                                            <BoxInner1>
                                                <DataContainer>
                                                    <Text2>{item.note}</Text2>

                                                </DataContainer>

                                            </BoxInner1>
                                            <LineContainer />
                                            <BoxInner1>
                                                <DataContainer>
                                                    <Text>{item.addedDate}</Text>
                                                    <Texts>Date & Time</Texts>
                                                </DataContainer>
                                                <MenuContainer>
                                                    <MenuIcon />
                                                </MenuContainer>
                                            </BoxInner1>
                                        </BoxContainer>
                                    ))
                                }
                            </>
                        )}


                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>


                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <NotesTabForm onClose={handleClose} fetchNotes={fetchNotes} />
                </DialogBox>
            </Container2>
        </>
    )
}

export default NotesCard
